export const convertArrayToObject = (arr: string[]): Record<string, string> =>
  arr.reduce((acc, curr) => ({ ...acc, [curr]: curr }), {});
